
import PortfolioKpiCostsIncomeModal from "@/components/portfolio/PortfolioKpiCostsIncomeModal";
import PortfolioKpiRealizedModal from "@/components/portfolio/PortfolioKpiRealizedModal";
import { privacyModeTextFormatterMixin } from '@/mixins';
import FormatterService from "@/service/FormatterService";

export default {
    name: 'RealizedKpiCard',
    
    components:{
        PortfolioKpiRealizedModal,
        PortfolioKpiCostsIncomeModal,
    },

    mixins: [privacyModeTextFormatterMixin],

    props: {
        loading: {
            type: Boolean,
            default: true,
        },
        selectedPortfolio: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            format: new FormatterService(),
            isRealizedModalOpen: false,
            isCostsAndRevenuesModalOpen: false,
        }
    },

    computed: {
        secondaryTotals() {
            return this.$store.state.preferences.kpiTotalData?.secondaryTotals || {};
        },
    },

    methods: {
        handleOpenRealizedModal() {
            this.isRealizedModalOpen = true;
        },
        handleOpenCostsAndRevenuesModal() {
            this.isCostsAndRevenuesModalOpen = true;
        },
    }
}
